export enum table{
    TOTALLIST = 'Total List',
    SCOUNT = 'Selected Count',
    FILTERHEAD = 'Filter',
    SAVEFILTERS = 'Save Filters',
    SELECTALL = 'Select All',
    CHANGEREQUEST = 'Change Request'
}